<template>
  <div class="two-factor-auth-view pt-4">
    <div class="two-factor-auth-header">
      <img
        width="300"
        src="@/assets/rectoplus_logo_white_font.png"
      >
    </div>
    <div class="form-two-factor-auth-container">
      <span class="two-factor-auth-title">{{ $t('views.two_factor_auth.title') }}</span>
      <span class="two-factor-auth-info">{{ $t('views.two_factor_auth.info') }}</span>

      <v-form
        class="two-factor-auth-form"
        @keyup.native.enter="verifyCode"
      >
        <ValidationObserver
          v-slot="{ invalid }"
          class="w-100"
        >
          <ValidationProvider
            v-slot="{ errors }"
            name="código"
            class="w-100"
            rules="required|length:4"
          >
            <label
              for="codeInput"
              class="label-two-factor-auth"
            >
              {{ $t('views.two_factor_auth.labels.code') }}
            </label>
            <v-text-field
              id="codeInput"
              v-model="code"
              class="text-field"
              :label="$t('views.two_factor_auth.placeholders.code')"
              type="text"
              background-color="field_register"
              flat
              solo
              maxlength="4"
              :error-messages="errors"
            />
          </ValidationProvider>

          <RectoplusButton
            :disabled="invalid"
            class="submit-button"
            :text="$t('views.two_factor_auth.verify_button')"
            @click="verifyCode"
          />

          <v-btn
            class="resend-button btn-link"
            text
            @click="resendCode"
          >
            {{ $t('views.two_factor_auth.resend_button') }}
          </v-btn>
        </ValidationObserver>
      </v-form>
      <router-link
        :to="{ name: 'login' }"
      >
        {{ $t('views.two_factor_auth.back_to_login') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import RectoplusButton from '@/components/buttons/RectoplusButton.vue';

export default {
  name: 'TwoFactorAuth',
  components: {
    RectoplusButton,
  },
  data() {
    return {
      code: '',
      email: '',
      userId: null,
    };
  },
  mounted() {
    this.email = this.$route.params.email;
    this.userId = this.$route.params.userId;

    if (!this.email || !this.userId) {
      this.$router.push({ name: 'login' });
      return;
    }

    this.sendTwoFactorCode();
  },
  methods: {
    ...mapActions([
      'initLoading',
      'removeLoading',
      'addSuccessMessage',
      'addErrorMessage',
    ]),

    sendTwoFactorCode() {
      this.initLoading();
      this.$store.dispatch('sendTwoFactorCode', {
        email: this.email,
      }).then(() => {
        this.addSuccessMessage(this.$t('views.two_factor_auth.code_sent'));
      }).catch(() => {
        this.addErrorMessage(this.$t('view.two_factor_auth.code_sent_error'));
      }).finally(() => {
        this.removeLoading();
      });
    },

    verifyCode() {
      if (!this.code || this.code.length !== 4) {
        return;
      }

      this.initLoading();
      this.$store.dispatch('verifyTwoFactorCode', {
        email: this.email,
        user_id: this.userId,
        two_factor_code: this.code,
      }).then(() => {
        this.$router.push({ name: 'home' });
      }).catch((error) => {
        this.addErrorMessage(error.response?.data.errors[0]);
        this.code = '';
      }).finally(() => {
        this.removeLoading();
      });
    },

    resendCode() {
      this.sendTwoFactorCode();
    },
  },
};
</script>

<style lang="scss" scoped>
.two-factor-auth-view {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .two-factor-auth-header {
    color: $title_color_primary;
    font-size: 40px;
    font-weight: bold;
  }

  .two-factor-auth-title {
    color: $title_color_primary;
    font-size: 26px;
    font-weight: bold;
  }

  .two-factor-auth-info {
    color: $subtitle_color_primary;
    font-size: 16px;
    margin-bottom: 16px;
    text-align: center;
  }

  .form-two-factor-auth-container {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    text-align: center;

    .two-factor-auth-form {
      margin: 32px 16px 16px;
      max-width: 400px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .label-two-factor-auth {
        color: $color_label_login;
        font-size: 16px;
        font-weight: 600;
        align-self: flex-start;
        margin-bottom: 8px;
      }

      .text-field {
        width: 100%;
        max-width: 500px;
        border-radius: 8px;
        text-align: center;
        ::v-deep .v-text-field__slot input {
          text-align: center;
          font-size: 24px;
          font-weight: bold;
          letter-spacing: 8px;
        }
      }

      .submit-button {
        width: 100%;
        max-width: 416px;
        margin: 20px 0px;
        font-size: 16px;
        height: 40px;
      }

      .resend-button {
        margin-top: 16px;
        color: $color_primary;
        text-transform: none;
        font-weight: bold;
      }
    }

    .btn-link {
      font-weight: bold;
      font-size: 16px;
      padding: 16px;
      color: $subtitle_color_primary;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
